import React, { useContext, useRef, useState } from "react";
import Input from "../../elements/Input";
import Button from "../../elements/Button";
import { request } from "../../utils/HttpRequest";
import { API_LINKS } from "../../constant/Links";
import { getFixedNumber } from "../../utils/Tools";
import { LoadingContext } from "../../context/Loading/LoadingContext";
import { AiOutlineFileSearch } from "react-icons/ai";

const inquiryRequest = (formData, setData, loadingContext) => {
  loadingContext.startLoading();
  request(
    API_LINKS.BASE + API_LINKS.PACKET.INQUIRY,
    formData,
    (res) => {
      inquirySuccess(res, setData, loadingContext);
    },
    (error) => {
      inquiryFailed(loadingContext);
    }
  );
};

const inquirySuccess = (res, setData, loadingContext) => {
  loadingContext.endLoading();
  setData(res);
};
const inquiryFailed = (loadingContext) => {
  loadingContext.endLoading();
  alert("اشکال در برقراری ارتباط با سرور");
};

const inquiryJSX = (data) => {
  if (data !== null) {
    if (data.status) {
      return (
        <div className=" grid grid-cols-2 rounded-2xl text-center text-lightTextPrimary dark:text-darkTextPrimary bg-lightPrimary dark:bg-darkPrimary">
          <div className="border-b-2 border-l-2 border-lightSecondary dark:border-darkSecondary border-dashed">
            <div className="p-3">
              <div>
                {data.info.laboratoryName + " (" + data.info.cityName + ")"}
              </div>
            </div>
          </div>
          <div className="border-b-2 border-lightSecondary dark:border-darkSecondary border-dashed">
            <div className="p-3">
              <div>
                {new Intl.DateTimeFormat("fa-IR").format(
                  new Date(data.info.createdAt)
                )}
              </div>
            </div>
          </div>
          <div className="border-b-2 border-l-2 text-3xl border-lightSecondary dark:border-darkSecondary border-dashed">
            <div className="p-3">
              <div>{data.info.number}</div>
            </div>
          </div>
          <div className="border-b-2 border-lightSecondary dark:border-darkSecondary border-dashed">
            <div className="font-extrabold text-5xl text-yellow-400 p-2">
              {getFixedNumber(parseFloat(data.info.cutie), 2)}
            </div>
          </div>
          <div className="col-span-2 border-dashed">
            <div className="p-3">
              <div className=" flex items-center justify-center">
                <img
                  className="rounded-lg"
                  src={API_LINKS.BASE_PIC + data.info.pic}
                />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <div className="text-center text-red-600">{data.msg}</div>;
    }
  } else {
    return null;
  }
};

const Inquiry = (props) => {
  const packetRef = useRef(null);

  const [validate, setValidate] = useState(false);

  const [data, setData] = useState(null);

  const loadingContext = useContext(LoadingContext);

  const submitHandle = () => {
    const packetNum = packetRef.current.value;
    if (packetNum.length < 8 || isNaN(parseInt(packetNum))) {
      setValidate(true);
      packetRef.current.focus()
      return;
    }
    const obj = {
      number: packetNum,
    };
    inquiryRequest(obj, setData, loadingContext);

    packetRef.current.value = "";
  };

  return (
    <section className="bg-lightPrimary dark:bg-darkPrimary ">
      <div className="grid  place-items-center">
        <div className="bg-lightSecondary dark:bg-darkSecondary rounded-2xl  shadow-2xl p-4 m-5 w-11/12 sm:w-4/6">
          {/* <h1 className="text-center text-2xl mb-4 dark:text-darkTextPrimary text-lightTextPrimary">
            استعلام شماره پاکت
          </h1> */}
          <div className="grid grid-cols-1 ">
            <div className="grid grid-cols-3 items-center justify-items-stretch justify-center">
              <div className="col-span-2">
                <Input
                  extraClass="rounded-2xl"
                  type="text"
                  refrence={packetRef}
                  inputMode="numeric"
                  placeHolder="شماره پاکت"
                  padding="p-3"
                  mode={validate ? "error" : "normal"}
                  message={validate ? "شماره پاکت حداقل باید 8 رقم باشد" : ""}
                  handler={() => {
                    setValidate(false);
                  }}
                />
              </div>
              <div className="text-center mt-5">
                <Button
                  extraClass=" text-darkTextPrimary "
                  padding="py-3 px-3"
                  icon={<AiOutlineFileSearch className="text-xl"/>}
                  type="submit"
                  variant="success"
                  content="استعلام"
                  rounded="rounded-2xl"
                  onClick={submitHandle}
                />
              </div>
            </div>
            {inquiryJSX(data)}
            <div className="text-gray-500 text-center mt-4 text-xs">
                  نسخه 1.0
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inquiry;
